import { useState, useEffect } from 'react';
import filterIcon from '../../../images/filter-icon.svg';
import { searchFilters } from '../../../content/filtersArray';
import * as Styled from './FilterStyles';
import FilterItem from './FilterItem';
import useObservable from '../../hooks/useObservable';
import SearchStore from '../../xstores/search';

interface FiltersProps{
  filters?: any,
  isOpen?: boolean,
  isSearch?: boolean,
  current?: object,
  onFilter: Function,
}
interface FilterMappingProps{
  [key:string]: string,
}
export const filterNameMap:FilterMappingProps = {
  Gmail: 'gmail',
  Slack: 'slack',
  'Microsoft Teams': 'teams',
  'Google Drive': 'gdrive',
  Dropbox: 'dropbox',
  JIRA: 'jira',
  Outlook: 'outlook',
  Office365: 'office-365',
  Email: 'email',
  Message: 'message',
  Link: 'link',
  File: 'file',
  'Show all': 'all',
}

const Filters = ({ isSearch, onFilter }:FiltersProps) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [platformFilters, setPlatformFilters] = useState<any[]>([]);
  const [typeFilters, setTypeFilters] = useState<any[]>([]);
  const [currentFilter, setCurrentFilter] = useState<any>({name: 'Show all'});
  const displayFilters = useObservable(SearchStore.displayFilters$, {});
  const normalizedResults = useObservable(SearchStore.normalizedResults$, []);
  const plFilter = useObservable(SearchStore.platformFilter$, 'all');
  const toggleFilters = () => {
    setFiltersOpen(!filtersOpen);
  }

  const onSelectFilter = (filter:any) => {
    setCurrentFilter(filter);
    if (isSearch) {
      SearchStore.setFilter(filterNameMap[filter.name]);
    } else {
      onFilter(filter);
    }
  }

  useEffect(() => {
    const { platforms, types } = displayFilters;
    if (!platforms || !platforms.length) {
      setFiltersOpen(false);
      setCurrentFilter({name: 'Show all'});
      return;
    }
    if ((platforms && platforms.length) || (types && types.length)) {
      setFiltersOpen(!!normalizedResults.length);
    } else {
      setFiltersOpen(false);
      setCurrentFilter({name: 'Show all'});
      return;
    }
    if (platforms && platforms.length) {
      const pls = searchFilters.filter((plf:any) => {
        const key = plf.platformKey || plf.name.toLowerCase();
        return platforms.indexOf(key) > -1;
      });
      setPlatformFilters(pls);
    }
    if (types && types.length) {
      const t = searchFilters.filter((plf: any) => {
        return types.indexOf(plf.name.toLowerCase()) > -1
      })
      setTypeFilters(t);
    }
  }, [displayFilters, normalizedResults]);

  useEffect(() => {
    if (plFilter === 'all') {
      setCurrentFilter({name: 'Show all'});
    }
  }, [plFilter]);

  return (
    <Styled.Wrapper>
      <Styled.Container onClick={toggleFilters} >
        <Styled.StyledSpan className="d-none d-sm-inline">
          {
            filtersOpen ?
              'Hide Filters'
              :
              'Show Filters'
          }
        </Styled.StyledSpan>
        <img src={filterIcon} alt="Filter icon"/>
      </Styled.Container>
      {filtersOpen && (
        <Styled.Container className={`HiddenBlock`}>
          {
            platformFilters.map( (e:any, i:number) => {
              return (
                <FilterItem
                  key={i}
                  e={e}
                  onSelect={onSelectFilter}
                  isActive={currentFilter.name === e.name}
                />
              );
            })
          }
          <Styled.VerticalDivider />
          {
            typeFilters.map( (e:any, i:number) => {
              return (
                <FilterItem
                  key={i}
                  e={e}
                  onSelect={onSelectFilter}
                  isActive={currentFilter.name === e.name}
                />
              );
            })
          }
          <Styled.VerticalDivider />
          <FilterItem
            e={{ name: 'Show all'}}
            onSelect={onSelectFilter}
            isActive={currentFilter.name === 'Show all'}
          />
        </Styled.Container>
      )}
    </Styled.Wrapper>
  )
}

export default Filters;